<template>
  <div>
    <SerialPack :url="url" cur-class="super_collect_pack2" />
  </div>
</template>

<script>
import SerialPack from '@/views/config/activity-auxiliary/superCollectPack.vue'
export default {
  name: 'SuperCollectPack2',
  components: {
    SerialPack
  },
  data() {
    return {
      url: '/config/activity-auxiliary/superCollectPack2'
    }
  }
}
</script>

<style scoped>

</style>
